export default __webpack_public_path__ + "static/media/type_15_8.4e55ba4f.svg";